import './Box.scss'

const Box = ({ children, ...props }) => {
  return (
    <div className="box-container" {...props}>
      {children}
    </div>
  )
}

export default Box
